var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mixpanelTracking } from '@/services/mixpanel';
import { DECIZAP_GO_RELAY, clearDecizapGoOffer, } from './offerStorage';
/**
 * Convite do Decizap Go para quem chegou pela LP: primeiro pergunta se o
 * usuário quer que a gente busque e aborde os leads; se ele topar, coleta o
 * mínimo para montar a lista (ICP) e escrever a abordagem, e manda tudo para o
 * relay da LP, que repassa ao Google Chat do time.
 */
let DecizapGoOffer = class DecizapGoOffer extends Vue {
    constructor() {
        super(...arguments);
        this.open = true;
        this.step = 'intro';
        this.loading = false;
        this.error = '';
        this.portes = ['MEI', 'Micro', 'Pequena', 'Média', 'Grande'];
        this.cargos = [
            'Dono / sócio',
            'Diretoria',
            'Compras / suprimentos',
            'Comercial',
            'Operações / produção',
            'TI',
            'Financeiro',
            'RH',
        ];
        this.form = {
            oferta: '',
            setores: '',
            portes: [],
            regiao: '',
            cargos: [],
            diferencial: '',
            excluir: '',
            whatsapp: '',
        };
    }
    mounted() {
        mixpanelTracking('Decizap Go: viu o convite');
    }
    toggle(list, option) {
        const index = list.indexOf(option);
        if (index >= 0)
            list.splice(index, 1);
        else
            list.push(option);
    }
    accept() {
        mixpanelTracking('Decizap Go: aceitou o convite');
        this.step = 'form';
    }
    decline() {
        mixpanelTracking('Decizap Go: recusou o convite');
        this.open = false;
    }
    /** Qualquer saída (recusa, envio, ESC, clique fora) encerra a oferta. */
    finish() {
        clearDecizapGoOffer();
        this.$emit('close');
    }
    validate() {
        const f = this.form;
        if (!f.oferta.trim())
            return 'Conta o que você vende.';
        if (!f.setores.trim())
            return 'Diz pelo menos um setor que você quer atingir.';
        if (!f.portes.length)
            return 'Escolhe pelo menos um porte de empresa.';
        if (!f.regiao.trim())
            return 'Diz a região (ou "Brasil todo").';
        if (!f.cargos.length)
            return 'Escolhe com quem a gente deve falar.';
        if (f.whatsapp.replace(/\D/g, '').length < 10)
            return 'Confere o WhatsApp: faltam dígitos.';
        return '';
    }
    async submit() {
        this.error = this.validate();
        if (this.error)
            return;
        this.loading = true;
        try {
            const response = await fetch(`${DECIZAP_GO_RELAY}/api/briefing`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    ...this.form,
                    email_lp: this.offer.email,
                    email_conta: this.user.email || '',
                    nome: this.user.name || '',
                    account_id: this.user.account_id || '',
                }),
            });
            if (!response.ok)
                throw new Error(`HTTP ${response.status}`);
            mixpanelTracking('Decizap Go: enviou o briefing');
            this.step = 'done';
        }
        catch (e) {
            this.error =
                'Não conseguimos enviar agora. Tenta de novo em alguns segundos.';
        }
        finally {
            this.loading = false;
        }
    }
};
__decorate([
    Prop({ required: true })
], DecizapGoOffer.prototype, "offer", void 0);
__decorate([
    Prop({ default: () => ({}) })
], DecizapGoOffer.prototype, "user", void 0);
DecizapGoOffer = __decorate([
    Component({ name: 'DecizapGoOffer' })
], DecizapGoOffer);
export default DecizapGoOffer;
